import { render, staticRenderFns } from "./DPPCountdown.vue?vue&type=template&id=400fc907&scoped=true&"
import script from "./DPPCountdown.vue?vue&type=script&lang=js&"
export * from "./DPPCountdown.vue?vue&type=script&lang=js&"
import style0 from "./DPPCountdown.vue?vue&type=style&index=0&id=400fc907&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400fc907",
  null
  
)

export default component.exports